module.exports = __webpack_public_path__ + "img/7e50bda.png";